module.exports = __webpack_public_path__ + "static/media/left_hand.2ba03da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/left_hand.png
// module id = 1277
// module chunks = 0